module.exports = __webpack_public_path__ + "img/vip-banner-bg.44570635.png";